import { createFileRoute } from "@tanstack/react-router";
import PartsAdminShell from "@/components/admin/parts/PartsAdminShell";

export const Route = createFileRoute("/_adminLayout/admin/parts")({
  component: PartsAdminShell,
});
